import { render, staticRenderFns } from "./accountForm.vue?vue&type=template&id=665e74cc&scoped=true"
import script from "./accountForm.vue?vue&type=script&lang=js"
export * from "./accountForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "665e74cc",
  null
  
)

export default component.exports